import { render, staticRenderFns } from "./AddByCat.vue?vue&type=template&id=17e66966&scoped=true&"
import script from "./AddByCat.vue?vue&type=script&lang=ts&"
export * from "./AddByCat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e66966",
  null
  
)

export default component.exports